type DateFormat = "date" | "time" | "dateTime" | "shortDate";

export const dateForm = (
  date: string | number | Date,
  format: DateFormat = "dateTime"
) => {
  try {
    const fechaObjeto = new Date(date);

    // Check if the date is valid
    if (Number.isNaN(fechaObjeto.getTime())) {
      console.warn("⚠️ Invalid date provided to dateForm:", date);
      return "Fecha inválida";
    }

    switch (format) {
      case "date":
        return fechaObjeto.toLocaleDateString("es-ES", {
          day: "2-digit",
          month: "long"
        });

      case "time":
        return fechaObjeto.toLocaleTimeString("es-ES", {
          hour: "2-digit",
          minute: "2-digit",
          hourCycle: "h23",
          timeZone: "America/Argentina/Buenos_Aires"
        });

      case "dateTime": {
        const fecha = fechaObjeto.toLocaleDateString("es-ES", {
          day: "2-digit",
          month: "long"
        });
        const hora = fechaObjeto.toLocaleTimeString("es-ES", {
          hour: "2-digit",
          minute: "2-digit",
          hourCycle: "h23",
          timeZone: "America/Argentina/Buenos_Aires"
        });
        return `${fecha} a las ${hora}`;
      }

      case "shortDate":
        return fechaObjeto.toLocaleDateString("es-ES", {
          day: "numeric",
          month: "short",
          year: "numeric"
        });

      default:
        return fechaObjeto.toLocaleString("es-ES", {
          day: "2-digit",
          month: "long",
          hour: "2-digit",
          minute: "2-digit",
          hourCycle: "h23",
          timeZone: "America/Argentina/Buenos_Aires"
        });
    }
  } catch (error) {
    console.error("❌ Error in dateForm function:", error);
    return "Error en fecha";
  }
};
